<div class="wrapper">
  <div class="container">
    <div class="container-fluid">
      @if (!canaleDiretto) {
        <div>
          <section class="banner position-relative">
            <div class="container position-relative">
              <div class="container-fluid">
                &nbsp;
                <span class="banner-title banner-title-first-line position-absolute"
                translate>homepage.banner-title</span>
                <span class="banner-subtitle banner-subtitle-first-line position-absolute pe-2"
                translate>homepage.banner-subtitle-first-line</span>
                <span class="banner-subtitle banner-subtitle-second-line position-absolute"
                translate>homepage.banner-subtitle-second-line</span>
              </div>
            </div>
          </section>
          <h2 class="text-center my-4" style="color: rgb(45, 45, 45); font-weight: bold">
            {{'header.welcome-message' | translate}}
            @if (user) {
              <span>{{ user.firstName }} {{ user.lastName }}</span>
              }!
            </h2>
            <h5 class="text-center introduction" translate>
              homepage.areas-introduction
            </h5>
            <div class="card full-card shadow-sm m-4 card-v-center mx-4">
              <div class="card-body mb-4">
                <h2 class="mb-4 text-center" style="color: rgb(45, 45, 45); font-weight: bold">
                  {{'homepage.select-module' | translate }}
                </h2>
                <div class="row justify-content-center">
                  <div fxLayout="column" fxLayoutAlign="start center" [class]="columnSize">
                    <div class="bazar-card" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_B2C_ACCESS]">
                      <img class="w-100" src="../../../../../assets/images/bandi.png" />
                      <h3 class="ps-2 my-4" translate>homepage.call.title</h3>
                      <div class="bazar-card-subtitle ps-2" translate>
                        homepage.call.subtitle
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center end">
                      <button class="ps-2 btn btn-primary mt-4" (click)="goToCalls()">
                        <span class="bazar-card-action" translate>
                          homepage.actions.enter-call-module
                        </span>
                        <!-- <span class="ps-2">➔</span> -->
                      </button>
                    </div>
                  </div>
                  <div fxLayout="column" fxLayoutAlign="start center" [class]="columnSize">
                    <div class="bazar-card" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_B2C_ACCESS]">
                      <img class="w-100" src="../../../../../assets/images/incentivi.png" />
                      <h3 class="ps-2 my-4" translate>homepage.incentive.title</h3>
                      <div class="bazar-card-subtitle ps-2" translate>
                        homepage.incentive.subtitle
                      </div>
                    </div>
                    <div fxLayout="row" fxLayoutAlign="center end">
                      <button class="ps-2 btn btn-primary mt-4 align-self-end" (click)="goToIncentives()">
                        <span class="bazar-card-action" translate>
                          homepage.actions.enter-incentive-module
                        </span>
                        <!-- <span class="ps-2">➔</span> -->
                      </button>
                    </div>
                  </div>
                  <!-- <div fxLayout="column" fxLayoutAlign="start center" [class]='columnSize' *ngIf="esgEnabled">
                  <div class="bazar-card">
                    <img class="w-100" src="../../../../../assets/images/esg_home.png">
                    <h3 class="ps-2 my-4" translate>homepage.esg.title</h3>
                    <div class="bazar-card-subtitle ps-2" translate>homepage.esg.subtitle</div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="center end">
                    <button class="ps-2 btn btn-primary mt-4" (click)="goToEsg()">
                      <span class="bazar-card-action" translate>
                        homepage.actions.enter-esg-module
                      </span>
                    </button>
                  </div>
                </div> -->
                <!-- <div fxLayout="column" fxLayoutAlign="start center" [class]='columnSize' *ngIf="vcfEnabled">
                <div class="bazar-card">
                  <img class="w-100" src="../../../../../assets/images/vcf.png">
                  <h3 class="ps-2 my-4" translate>homepage.vcf.title</h3>
                  <div class="bazar-card-subtitle ps-2" translate>homepage.vcf.subtitle</div>
                </div>
                <div fxLayout="row" fxLayoutAlign="center end">
                  <button class="ps-2 btn btn-primary mt-4 pv-0" (click)="goToVcf()">
                    <span class="bazar-card-action" translate>
                      homepage.actions.enter-vcf-module
                    </span>
                  </button>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    }
    <!-- End Canale Banca -->

    <!-- Start Piattaforma italia -->
    @if (canaleDiretto) {
      <div>
        <!-- Intro questionario -->
        <app-questionnaire-intro></app-questionnaire-intro>
        <!-- Aree Tematiche -->
        <app-thematic-areas></app-thematic-areas>
        <!-- Modulo Bandi e Incentivi -->
        <app-bandi-incentivi-module></app-bandi-incentivi-module>
        <!-- Percorso -->
        @if (!directChannelLimited) {
          <app-journey></app-journey>
        }
        <!-- Servizi consigliati -->
        @if (!directChannelLimited) {
          <app-recommended-services></app-recommended-services>
        }
        <!-- B&I -->
        <app-bandi-incentivi></app-bandi-incentivi>
      </div>
    }
  </div>
</div>
</div>
